// app/javascript/controllers/toast_item_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 8000 },
    key: { type: String, default: "" },
  };

  static targets = ["progress"];

  connect() {
    // check if we are on conversations page and we have a new message notification
    // so we can skip showing it
    if (
      document.getElementById("sidebar-conversations") &&
      this.keyValue === "new_message_in_conversation"
    ) {
      this.element.remove();
    } else {
      this.element.classList.remove("hidden");
      // Start the radial progress animation
      this.animateRadialProgress();
    }
    // Automatically dismiss the toast after the duration
    setTimeout(() => this.dismiss(), this.durationValue);
  }

  animateRadialProgress() {
    const progressElement = this.progressTarget;
    if (!progressElement) return;

    // Set initial value to 0
    progressElement.style.setProperty("--value", "0");

    // Use requestAnimationFrame for smooth animation
    const startTime = performance.now();
    const duration = this.durationValue;

    const updateProgress = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      if (elapsedTime >= duration) {
        // Set to 100% when time is up
        progressElement.style.setProperty("--value", "100");
        return;
      }
      // Calculate progress percentage (0-100)
      const progressValue = Math.min(
        100,
        Math.floor((elapsedTime / duration) * 100)
      );
      // Update the CSS variable and aria attribute
      progressElement.style.setProperty("--value", progressValue.toString());

      // Continue animation
      requestAnimationFrame(updateProgress);
    };

    // Start the animation
    requestAnimationFrame(updateProgress);
  }

  dismiss() {
    // Add a custom class to trigger fade-out and slide animation
    this.element.classList.add("animate-fade-out");
    // Remove the element after the animation completes (300ms)
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
